import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@material-ui/core';
import { FeedRegistration, formatFeedAmount } from '../../models/feed-registration';

export interface FeedPeriodSummaryProps {
  registrations: FeedRegistration[];
  totalCount: number;
}

/**
 * Count of registrations in the period, plus their total feed.
 *
 * The total is only shown when the current page holds every registration in the period. Summing a
 * page would put a number on screen that silently means "the first 100 rows", which is worse than
 * showing no total at all.
 */
const FeedPeriodSummary: React.FC<FeedPeriodSummaryProps> = ({ registrations, totalCount }) => {
  const { t } = useTranslation();

  if (totalCount === 0) return null;

  const isComplete = registrations.length === totalCount;
  const totalGrams = registrations.reduce((sum, registration) => sum + registration.amountGrams, 0);

  return (
    <div className="flex items-center gap-2">
      <Chip size="small" label={t('f-feed-reg-count', { count: totalCount })} className="!bg-gray-100 !text-gray-700" />
      {isComplete && (
        <Chip
          size="small"
          label={t('f-feed-reg-total', { amount: formatFeedAmount(totalGrams) })}
          className="!bg-green-100 !text-green-800"
        />
      )}
    </div>
  );
};

export default FeedPeriodSummary;
